<template>
  <div v-if="playlists.length > 0">
    <div class="list-group-item header">Playlists</div>
    <sidebar-link
      v-for="pl in playlists"
      :key="pl.id"
      :href="`/playlists/${pl.id}`"
      class="indent-1"
    >{{ truncate(pl.name, 25) }}</sidebar-link>
  </div>
</template>

<script>
import SidebarLink from './sidebar_link.vue'

export default {
  components: { SidebarLink },
  props: {
    playlists: { type: Array, default: () => [] },
  },
  methods: {
    truncate(str, length) {
      if (!str) return ''
      if (str.length <= length) return str
      return str.slice(0, length - 3) + '...'
    }
  }
}
</script>
